// extracted by mini-css-extract-plugin
module.exports = {"root":"Avatar_root__28-IR","initial":"Avatar_initial__32BT3","imgAvatar":"Avatar_imgAvatar__2RwbY"};